<template>

    <v-app>

        <NavBarOpc />

        <v-main>

            <HeroSection />

            <!-- <FeaturedMove /> -->

            <LevelSection />

            <!-- <PopularSection /> -->

            <CategorySection />

        </v-main>

    </v-app>

</template>

<script>

import NavBarOpc from "@/components/NavBarOpc.vue";

import HeroSection from "@/components/home/HeroSection.vue";
// import FeaturedMove from "@/components/home/FeaturedMove.vue";
import LevelSection from "@/components/home/LevelSection.vue";
// import PopularSection from "@/components/home/PopularSection.vue";
import CategorySection from "@/components/home/CategorySection.vue";

export default{

    name:"HomeView",

    components:{

        NavBarOpc,

        HeroSection,

        // FeaturedMove,

        LevelSection,

        // PopularSection,

        CategorySection

    }

}

</script>

<style scoped>

.v-application{

    background:#111;

}

</style>